import React from "react";
import {
  Badge,
  Button,
  Card,
  CardBody,
  CardHeader,
  HStack,
  Heading,
  Select,
  SkeletonText,
  Table,
  TableContainer,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr,
} from "@chakra-ui/react";
import EmptyState from "./EmptyState";

const ReportInvoicesPanel = ({
  invoices,
  isLoading,
  statusOptions,
  statusFilter,
  onStatusChange,
  onPrint,
  formatCurrency,
  formatDateTime,
  statusColor,
}) => {
  return (
    <Card variant="outline" _hover={{ boxShadow: "md" }} transition="box-shadow 0.2s ease">
      <CardHeader>
        <HStack justify="space-between" flexWrap="wrap" gap={3}>
          <Heading size="sm">All Invoices</Heading>
          <HStack spacing={3}>
            <Select
              size="sm"
              value={statusFilter}
              onChange={(event) => onStatusChange(event.target.value)}
            >
              <option value="all">All statuses</option>
              {statusOptions.map((status) => (
                <option key={status} value={status}>
                  {status}
                </option>
              ))}
            </Select>
            <Button size="sm" variant="outline" onClick={onPrint}>
              Print PDF
            </Button>
            <Text fontSize="sm" color="gray.500">
              {invoices.length} records
            </Text>
          </HStack>
        </HStack>
      </CardHeader>
      <CardBody>
        {isLoading ? (
          <SkeletonText noOfLines={6} spacing="3" />
        ) : invoices.length === 0 ? (
          <EmptyState title="No invoices" description="No invoices match the selected filters." />
        ) : (
          <TableContainer>
            <Table size="sm">
              <Thead>
                <Tr>
                  <Th>Invoice</Th>
                  <Th>Customer</Th>
                  <Th isNumeric>Amount</Th>
                  <Th>Status</Th>
                  <Th>Created</Th>
                  <Th>Due</Th>
                  <Th>Paid</Th>
                </Tr>
              </Thead>
              <Tbody>
                {invoices.map((invoice) => (
                  <Tr key={invoice.id}>
                    <Td>{invoice.invoiceNumber || `#${invoice.id}`}</Td>
                    <Td>{invoice.customerEmail}</Td>
                    <Td isNumeric>{formatCurrency(invoice.amount, invoice.currency)}</Td>
                    <Td>
                      <Badge colorScheme={statusColor(invoice.status)}>{invoice.status}</Badge>
                    </Td>
                    <Td>{formatDateTime(invoice.createdDate)}</Td>
                    <Td>{formatDateTime(invoice.dueDate)}</Td>
                    <Td>{formatDateTime(invoice.paidDate)}</Td>
                  </Tr>
                ))}
              </Tbody>
            </Table>
          </TableContainer>
        )}
      </CardBody>
    </Card>
  );
};

export default ReportInvoicesPanel;
